export default __webpack_public_path__ + "static/media/Image-Benefit2.75a3dde6.png";